// extracted by mini-css-extract-plugin
export var dateLabel = "_41-0";
export var dateLabelError = "_41-1";
export var fullWidth = "_41-2";
export var smaller = "_41-3";